<div class="container-fluid">
    <app-pagetitle title="Stamp inventory"></app-pagetitle>

    <div class="page-content-wrapper">

        <app-loader [loading]="loading"></app-loader>

        <div [class.loading-content]="loading">

            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <app-filter (filterChange)="filterChange($event)" [statusOptions]="statusOptions"
                                searchBY="Batch Id, Serial Number, Stamp Value & State "></app-filter>

                            <p-table #dt [value]="inventory" [lazy]="true" (onLazyLoad)="getInventory($event)"
                                [paginator]="true" [rows]="rows" [totalRecords]="totalRecords"
                                [rowsPerPageOptions]="[10,20,50]" responsiveLayout="scroll"
                                styleClass="p-datatable-sm fs-6" [showCurrentPageReport]="true"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Batch Id</th>
                                        <th>Serial Number</th>
                                        <th>Stamp Value</th>
                                        <th>State</th>
                                        <th>Status</th>
                                        <th>Created</th>
                                        <th>Action</th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-document>
                                    <tr>
                                        <td class="fw-bold">{{document.batchId}}</td>
                                        <td>{{document.serialNumber}}</td>
                                        <td>₹{{document.stampValue}}</td>
                                        <td>{{document.stateName}}</td>

                                        <td>
                                            <span class="badge rounded-pill px-2 py-1 small"
                                                [ngClass]="getStatusClass(document.status)">
                                                {{ document.status }}
                                            </span>
                                        </td>

                                        <td>{{ document.createdAt | date:'dd/MM/yyyy hh:mm a' }}</td>

                                        <td class="text-center">
                                            <button class="btn btn-sm btn-light" [disabled]="!document.pdfUrl"
                                                (click)="previewFile(document)" ngbTooltip="file">
                                                <i class="mdi mdi-eye-outline"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="9" class="text-center py-4 text-muted">
                                            <i class="mdi mdi-database-off-outline me-2"></i>
                                            No document found
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>